// extracted by mini-css-extract-plugin
export default {"changeStatusDialog":"ChangeStatusDialog_changeStatusDialog__r2B+R"};